<template>
    <div>
        <v-container>
            <v-card>
                <v-card-title> Coupon Codes </v-card-title>
                <v-card-text>
                    <v-btn color="primary" @click="showModal = true">Add Coupon Code</v-btn>
                    <br /><br />
                    <v-data-table :headers="headers" :items="couponCodes" @click:row="editPromoCode" class="elevation-1">
                        <!-- ... other code ... -->
                        <template v-slot:item.status="{ item }">
                            <v-chip :color="getChipColor(item.status)" small>{{ item.status }}</v-chip>
                        </template>

                        <template v-slot:item.start_date="{ item }">
                            {{ formatDate(item.start_date) }}
                        </template>
                        <template v-slot:item.end_date="{ item }">
                            {{ formatDate(item.end_date) }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2"
                                @click.stop="editPromoCode(item)">mdi-pencil</v-icon>
                            <v-icon small class="mr-2" @click.stop="showDetails(item)">mdi-information</v-icon>

                        </template>
                    </v-data-table>
                    <v-dialog v-model="showModal" max-width="500" persistent>
                        <v-card>
                            <v-card-title v-if="selectedPromoCode"> Edit Coupon Code </v-card-title>
                            <v-card-title v-else> Add Coupon Code </v-card-title>
                            <v-card-text>
                                <v-text-field label="Coupon Name" v-model="newCouponName" :disabled="!!selectedPromoCode"></v-text-field>
                                <v-text-field label="Coupon Code" v-model="newPromoCode" :disabled="!!selectedPromoCode"></v-text-field>
                                <label for="">start time</label>
                                <flat-pickr class="flat-pickr-text-field" v-model="newStartDate"
                                    :config="datePickerConfig"></flat-pickr>
                                <label for="">end time</label>
                                <flat-pickr class="flat-pickr-text-field" v-model="newEndDate"
                                    :config="datePickerConfig"></flat-pickr>
                                <v-text-field label="Enter Amount" v-model="newAmount" :disabled="!!selectedPromoCode"></v-text-field>
                                <v-select v-if="selectedPromoCode" v-model="newStatus" :items="items"
                                    label="Status"></v-select>
                                <v-select v-model="assetType" :disabled="!!selectedPromoCode" :items="assetsTypes" label="Pick Asset Type"
                                    @change="refreshAssets()"></v-select>
                                <v-select label="Pick asset" v-model="asset_id" :disabled="!!selectedPromoCode" :items="stores" item-text="name"
                                    item-value="id" v-if="stores.length > 0" @change="category_id = ''">
                                    <!-- <template v-slot:item="{ item }">
                                        <v-list-item>
                                            <v-list-item-avatar>
                                                <img :src="item.icon" alt="Option Image" width="24" height="24" />
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template> -->
                                </v-select> 
                                <v-select label="Pick sub-category" v-model="category_id" :disabled="!!selectedPromoCode" :items="categories" item-text="name"
                                    item-value="id" v-if="assetType === 'giftcard'">
                                </v-select> 
                                 <v-text-field v-if="!selectedPromoCode && assetType== 'crypto'" label="Enter duration (in hours)" v-model="newDuration"></v-text-field>
                              
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary"
                                    @click="selectedPromoCode ? updatePromoCode() : addPromoCode()">Add</v-btn>
                                <v-btn @click="closeModal">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="showDetailsModal" max-width="500">
                        <v-card>
                            <v-card-title>Beneficiaries</v-card-title>
                            <v-card-text>
                                <!-- Display the details of the selected row -->
                                <v-list>


                                    <v-list-item-group>
                                        <v-list-item v-for="item in selectedCouponUsers" :key="item.id">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <strong>User:</strong> {{ item.user.username }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn @click="navigateToCustomerPage(item.user.id)" text>
                                                    View Customer
                                                </v-btn>
                                            </v-list-item-action>

                                        </v-list-item>

                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn @click="showDetailsModal = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>


<script>
import VueFlatpickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { PromoService, StoresService, CryptoService } from "@/services";
import app from '@/main'

export default {
    components: {
        flatPickr: VueFlatpickr
    },
    data() {
        return {
            format: "Y-m-d H:i:S",
            items: ["active", "inactive"],
            assetsTypes: ['crypto', 'giftcard'],
            assetType: 'giftcard',
            showDetailsModal: false,
            selectedRowData: null,
            selectedCouponUsers: [],
            allStores: [],
            stores: [],
            categories: [],
            couponCodes: [],
            asset_id: '',
            category_id: '',
            headers: [
                { text: "Coupon Name", value: "coupon_name" },
                { text: "Coupon Code", value: "coupon_code" },
                { text: "Start Date", value: "start_date" },
                { text: "End Date", value: "end_date" },
                { text: "Asset Type", value: "asset_type" },
                { text: "status", value: "status" },
                { text: "Amount", value: "amount" },
                { text: "Actions", value: "actions", sortable: false }
            ],
            showModal: false,
            newPromoCode: "",
            newAmount: 0,
            newCouponName: '',
            newDuration: 0,
            newStatus: 'pending',
            startDatePicker: null,
            endDatePicker: null,
            newStartDate: new Date(),
            newEndDate: new Date(),
            selectedPromoCode: null,
            // datePickerConfig: {
            //     enableTime: true, // Enable time selection
            //     dateFormat: "Y-m-d H:i:S",
            //     time_24hr: true,
            //     minuteIncrement: 1,
            //     clickOpens: !this.selectedPromoCode
            // }
        };
    },
    computed: {
        datePickerConfig() {
            return {
                enableTime: true, // Enable time selection
                dateFormat: "Y-m-d H:i:S",
                time_24hr: true,
                minuteIncrement: 1,
                clickOpens: !this.selectedPromoCode
            };
        }
    },
    async mounted() {
        await this.retrieveAllPromoCode();
        await this.refreshAssets();
    },
    methods: {
        navigateToCustomerPage(userId) {
            // Use Vue Router to navigate to the customer page
            this.$router.push({ name: 'Customer', params: { id: userId } });
        },
        getStatusColor(status) {
            switch (status) {
                case 'pending':
                    return 'yellow';
                case 'paid':
                    return 'green';
                case 'ended':
                    return 'red';
                default:
                    return 'defaultColor';
            }
        },
        getChipColor(status) {
            if (status === 'active') {
                return 'green';
            } else if (status === 'pending') {
                return 'yellow';
            } else {
                return 'red';
            }
        },
        async showDetails(item) {
            // Set the selected row's data to a property
            //  this.selectedRowData = item;
            const resp = await PromoService.getCouponUsers(item.id);
            console.log("the item is:,", item);
            // Open the modal
            this.showDetailsModal = true;
            this.selectedCouponUsers = resp.data;
        },
        async retrieveAllPromoCode() {
            // app.$store.dispatch('toast', {
            //     message: 'loading coupon codes...',
            //     variant: 'info'
            // });
            const promosResp = await PromoService.getAllCoupon();

            if (promosResp) this.couponCodes = promosResp.data;
        },
        openStartDatePicker() {
            this.startDatePicker.open();
        },
        openEndDatePicker() {
            this.endDatePicker.open();
        },
        async refreshAssets() {
            let stores = [];
            if (this.assetType == 'giftcard') {
                const storesResp = await StoresService.getStores();
                this.allStores = storesResp;
                storesResp.forEach((store) => {
                    stores.push({ id: store.id, icon: store.icon, name: store.name })
                })

            }
            else {
                const coinResp = await CryptoService.getCoins();
                coinResp.forEach((store) => {
                    stores.push({ id: store.id, icon: store.logoURL, name: store.coinName });
                })
            }
            this.stores = stores;
        },
        async addPromoCode() {
            app.$store.dispatch('toast', {
                message: 'uploading coupon code...',
                variant: 'info'
            });
            const data = {
                coupon_code: this.newPromoCode,
                coupon_name: this.newCouponName,
                amount: this.newAmount,
                duration: this.newDuration,
                asset_type: this.assetType,
                asset_id: this.assetType == 'giftcard' ? this.category_id :this.asset_id,
                start_date: this.newStartDate.toLocaleString('en-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                }).replace(',', ''),
                end_date: this.newEndDate.toLocaleString('en-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                }).replace(',', ''),
                status: this.newStatus,
            };
            const promosResp = await PromoService.createCouponCode(data);
            console.log('handle submt', promosResp);
            await this.retrieveAllPromoCode();
            if (promosResp) {
                app.$store.dispatch('toast', {
                    message: 'Coupon code created successfully...',
                    variant: 'success'
                });
            }
            // await this.retrieveAllPromoCode();
            // this.couponCodes.push(promosResp.data);
            this.newPromoCode = "";
            this.newAmount = 0;
            this.duration = 0; 
            this.newStartDate = new Date();
            this.newEndDate = new Date();
            this.showModal = false;
        },
        editPromoCode(promoCode) {
            this.newCouponName = promoCode.coupon_name;
            this.selectedPromoCode = promoCode;
            this.assetType = promoCode.asset_type;
            this.asset_id = promoCode.asset_id,
                this.newPromoCode = promoCode.coupon_code;
            this.coupon_name = promoCode.coupon_name;
            this.newStartDate = promoCode.start_date;
            this.newEndDate = promoCode.end_date;
            this.newStatus = promoCode.status;
            this.newAmount = promoCode.amount;
            this.showModal = true;
        },
        async updatePromoCode() {
            app.$store.dispatch('toast', {
                message: 'updating coupon code...',
                variant: 'info'
            });
            this.selectedPromoCode.coupon_code = this.newPromoCode;
            this.selectedPromoCode.coupon_name = this.newCouponName;
            this.selectedPromoCode.asset_id = this.asset_id;
            this.selectedPromoCode.asset_type = this.assetType;
            this.selectedPromoCode.start_date = this.newStartDate;
            this.selectedPromoCode.end_date = this.newEndDate;
            this.selectedPromoCode.amount = this.newAmount;
            this.selectedPromoCode.status = this.newStatus;
            const resp = await PromoService.editCoupon(this.selectedPromoCode);

            this.selectedPromoCode = null;
            if (resp) app.$store.dispatch('toast', {
                message: 'coupon updated successfully',
                variant: 'success'
            });
            this.newPromoCode = "";
            this.newCouponName = "";
            this.asset_id = '';
            this.assetType = 'giftcard';
            this.newStartDate = new Date();
            this.newEndDate = new Date();
            this.newAmount = 0;
            this.showModal = false;
        },
        removePromoCode(promoCode) {
            this.couponCodes = this.couponCodes.filter(p => p !== promoCode);
        },
        closeModal() {
            this.showModal = false
            // reset
            this.newCouponName = '';
            this.selectedPromoCode = null;
            this.assetType = 'giftcard';
            this.asset_id = '';
            this.newPromoCode = "";
            this.coupon_name = "";
            this.newStartDate = new Date();
            this.newEndDate = new Date();
            this.newStatus = 'pending';
            this.newAmount = 0;
        },
        formatDate(date) {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false, // Use 24-hour format
            };
            return new Date(date).toLocaleString(undefined, options);
        }

    },
    watch: {
        async asset_id() {
            if (this.assetType === 'giftcard') {
                const data = await StoresService.loadGiftcards({
                    store: this.asset_id
                });
                const categories = data
                categories.forEach((category) => {
                    this.categories.push({ id: category.id, name: `${category.name} ${category.cardMin ? `(${category.country.currencySymbol}${category.cardMin} - ${category.country.currencySymbol}${category.cardMax})` : ''} - (${category.type} card)` })
                })
            } else {
                this.categories = [];
                this.category_id = '';
            }
        }
    }
};
</script>
  
<style scoped>
.flat-pickr-text-field {
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
}
</style>
  